import { render, staticRenderFns } from "./RACI.vue?vue&type=template&id=6624e806&scoped=true&"
import script from "./RACI.vue?vue&type=script&lang=js&"
export * from "./RACI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624e806",
  null
  
)

export default component.exports